const kantoItems = {
  "WKJ0094": ["シティマリーナヴェラシス", "35.23595", "139.7316", "MWW", "WKJ0094", "相模湾中央", "", "", "", "", "", "", "001"],
  "WKJ0095": ["剣崎", "35.14171", "139.68111", "MWW", "WKJ0094", "相模湾中央", "", "", "", "", "", "", "001"],
  "WKJ0096": ["野島埼", "34.89478", "139.88856", "MWW", "WKJ0094", "房総半島南海上", "", "", "", "", "", "", "002", "千葉海上保安部", "https://www6.kaiho.mlit.go.jp/03kanku/chiba/kisyou.html"],
  "WKJ0097": ["伊東", "34.98819", "139.10581", "MWW", "WKJ0094", "相模湾中央", "", "", "", "", "", "", "002"],
  "WKJ0098": ["石廊崎", "34.57103", "138.8435", "MWW", "WKJ0094", "伊豆半島南海上", "", "", "", "", "", "", "002"],
  "WKJ0099": ["大島", "34.82051", "139.38111", "MWW", "WKJ0094", "大島南海上", "", "", "", "", "", "", "002"],
  "WKJ0100": ["佐島マリーナ", "35.22015", "139.60293", "MWW", "WKJ0094", "相模湾中央", "", "", "", "", "", "", "002"],
  "WKJ0101": ["江の島", "35.29492", "139.48071", "MWW", "WKJ0094", "相模湾中央", "", "", "", "", "", "", "002"],
  "WKJ0102": ["真鶴マリーナ", "35.15172", "139.15582", "MWW", "WKJ0094", "相模湾中央", "", "", "", "", "", "", "002"],
  "WKJ0103": ["初島", "35.03239", "139.17114", "MWW", "WKJ0094", "相模湾中央", "", "", "", "", "", "", "002"],
  "WKJ0128": ["大洗マリーナ", "36.30569", "140.571688", "MWW", "WKJ0128", "房総半島南海上", "", "", "", "", "", "", "008"],
  "WKJ0129": ["銚子", "35.71517", "140.88747", "MWW", "WKJ0129", "房総半島南海上", "", "", "", "", "", "", "0081", "銚子海上保安部", "https://www6.kaiho.mlit.go.jp/03kanku/choshi/kinkyu.html"],
  "WKJ0130": ["大洗沖", "36.327338", "140.811638", "MWW", "WKJ0130", "房総半島南海上", "", "", "", "", "", "", "008"],
  "WKJ0131": ["塩屋崎", "36.995489", "140.993213", "MWW", "WKJ0131", "房総半島南海上", "", "", "", "", "", "", "008"],
  "WKJ0132": ["夢の島マリーナ", "35.62624", "139.85533", "MWW", "WKJ0132", "相模湾中央", "", "", "", "", "", "", "009", "東京海上保安部", "https://www6.kaiho.mlit.go.jp/03kanku/tokyo/kisyou.html"],
  "WKJ0133": ["風の塔(アクアライン) ", "35.49134", "139.83473", "MWW", "WKJ0133", "相模湾中央", "", "", "", "", "", "", "009", "東京海上保安部", "https://www6.kaiho.mlit.go.jp/03kanku/tokyo/kisyou.html"],
  "WKJ0134": ["本牧沖", "35.44045", "139.70701", "MWW", "WKJ0134", "相模湾中央", "", "", "", "", "", "", "009"],
}

const pointConfig = {
  "001": {
    "key": "001",
    "id": "WKJ0094",
    "name": "シティマリーナヴェラシス",
    "location": {
      "lat": "35.23595",
      "lng": "139.7316"
    },
    "link": "https://www6.kaiho.mlit.go.jp/03kanku/yokosuka/kisyou.html",
    "linkName": "横須賀海上保安部",
    "items": kantoItems,
  },
  "002": {
    "key": "002",
    "id": "WKJ0100",
    "name": "佐島マリーナ",
    "location": {
      "lat": "35.22015",
      "lng": "139.60293"
    },
    "link": "https://www6.kaiho.mlit.go.jp/03kanku/shimoda/kisyou.html",
    "linkName": "下田海上保安部",
    "items": kantoItems,
  },
  "003": {
    "key": "003",
    "id": "WKJ0102",
    "name": "真鶴マリーナ",
    "location": {
      "lat": "35.15172",
      "lng": "139.15582"
    },
    "link": "https://www6.kaiho.mlit.go.jp/03kanku/shimoda/kisyou.html",
    "linkName": "下田海上保安部",
    "items": kantoItems,
  },
  "004": {
    "key": "004",
    "id": "WKJ0104",
    "name": "三河御津マリーナ",
    "location": {
      "lat": "34.79827",
      "lng": "137.29295"
    },
    "link": "https://www6.kaiho.mlit.go.jp/04kanku/nagoya/kisyou.html",
    "linkName": "名古屋海上保安部",
    "items": {
      "WKJ0104": ["三河御津マリーナ", "34.79827", "137.29295", "MWW", "WKJ0104", "三河湾", "", "", "", "", "", "", "004"],
      "WKJ0105": ["波ケ崎灯台", "34.72813", "137.02678", "MWW", "WKJ0104", "三河湾", "", "", "", "", "", "", "004"],
      "WKJ0106": ["伊良湖岬", "34.58094", "137.00861", "MWW", "WKJ0104", "三河湾", "", "", "", "", "", "", "004"],
      "WKJ0107": ["鳥羽", "34.49584", "136.85961", "MWW", "WKJ0104", "大王崎沖合", "", "", "", "", "", "", "004"],
      "WKJ0108": ["御前崎", "34.56563", "138.21798", "MWW", "WKJ0104", "御前崎沖合", "", "", "", "", "", "", "004", "清水海上保安部", "https://www6.kaiho.mlit.go.jp/03kanku/shimizu/kisyou.html"],
      "WKJ0109": ["大王崎", "34.27624", "136.90491", "MWW", "WKJ0104", "大王崎沖合", "", "", "", "", "", "", "004"],
      "WKJ0110": ["浜名湖沖", "34.64772", "137.59217", "MWW", "WKJ0104", "浜松市沖合", "", "", "", "", "", "", "004"],
    }
  },
  "005": {
    "key": "005",
    "id": "WKJ0111",
    "name": "仁尾マリーナ",
    "location": {
      "lat": "34.20436",
      "lng": "133.63074"
    },
    "link": "https://www6.kaiho.mlit.go.jp/06kanku/takamatsu/kisyou.html",
    "linkName": "高松海上保安部",
    "items": {
      "WKJ0111": ["仁尾マリーナ", "34.20436", "133.63074", "MWW", "WKJ0111", "GSMで対応？もしくはなし", "", "", "", "", "", "", "005"],
      "WKJ0112": ["三崎付近", "34.26207", "133.54927", "MWW", "WKJ0111", "GSMで対応？もしくはなし", "", "", "", "", "", "", "005"],
      "WKJ0113": ["伊吹島", "34.14146", "133.54393", "MWW", "WKJ0111", "GSMで対応？もしくはなし", "", "", "", "", "", "", "005"],
      "WKJ0114": ["粟島", "34.27587", "133.61082", "MWW", "WKJ0111", "GSMで対応？もしくはなし", "", "", "", "", "", "", "005"],
      "WKJ0115": ["燧灘中央(ひうちなだ）", "34.11556", "133.16857", "MWW", "WKJ0111", "GSMで対応？もしくはなし", "", "", "", "", "", "", "005"],
      "WKJ0116": ["尾道", "34.34759", "133.23101", "MWW", "WKJ0111", "GSMで対応？もしくはなし", "", "", "", "", "", "", "005", "今治海上保安部", "https://www6.kaiho.mlit.go.jp/06kanku/onomichi/kisyou.html"],
    }
  },
  "006": {
    "key": "006",
    "id": "WKJ0117",
    "name": "新居浜マリーナ",
    "location": {
      "lat": "33.99348",
      "lng": "133.33105"
    },
    "link": "https://www6.kaiho.mlit.go.jp/06kanku/imabari/kisyou.html",
    "linkName": "今治海上保安部",
    "items": {
      "WKJ0117": ["新居浜マリーナ", "33.99348", "133.33105", "MWW", "WKJ0117", "GSMで対応？もしくはなし", "", "", "", "", "", "", "006"],
      "WKJ0118": ["魚島", "34.16352", "133.31497", "MWW", "WKJ0117", "GSMで対応？もしくはなし", "", "", "", "", "", "", "006"],
      "WKJ0119": ["上島町", "34.25617", "133.22528", "MWW", "WKJ0117", "GSMで対応？もしくはなし", "", "", "", "", "", "", "006"],
      "WKJ0120": ["来島海峡", "34.09619", "133.0091", "MWW", "WKJ0117", "GSMで対応？もしくはなし", "", "", "", "", "", "", "006"],
    }
  },
  /* // 2024年3月で終了
  "007": {
    "key": "007",
    "id": "WKJ0121",
    "name": "ハウステンボスマリーナ",
    "location": {
      "lat": "33.07549",
      "lng": "129.79092"
    },
    "link": "https://www6.kaiho.mlit.go.jp/07kanku/nagasaki/kisyou.html",
    "linkName": "長崎海上保安部",
    "items": {
      "WKJ0121": ["ハウステンボスマリーナ", "33.07549", "129.79092", "MWW", "WKJ0121", "平戸島付近", "", "", "", "", "", "", "007"],
      "WKJ0122": ["針尾", "33.08878", "129.72418", "MWW", "WKJ0121", "平戸島付近", "", "", "", "", "", "", "007"],
      "WKJ0123": ["佐世保", "33.15252", "129.71527", "MWW", "WKJ0121", "平戸島付近", "", "", "", "", "", "", "007"],
      "WKJ0124": ["長崎空港", "32.93717", "129.89424", "MWW", "WKJ0121", "平戸島付近", "", "", "", "", "", "", "007"],
      "WKJ0125": ["九十九島", "33.15171", "129.65132", "MWW", "WKJ0121", "平戸島付近", "", "", "", "", "", "", "007"],
      "WKJ0126": ["平戸", "33.17418", "129.48456", "MWW", "WKJ0121", "平戸島付近", "", "", "", "", "", "", "007"],
      "WKJ0127": ["福江島", "32.54584", "128.59447", "MWW", "WKJ0121", "平戸島付近", "", "", "", "", "", "", "007"],
    }
  },*/
  "008": {
    "key": "008",
    "id": "WKJ0128",
    "name": "大洗マリーナ",
    "location": {
      "lat": "36.30569",
      "lng": "140.571688"
    },
    "link": "https://www6.kaiho.mlit.go.jp/03kanku/ibaraki/kinkyu.html",
    "linkName": "茨城海上保安部",
    "items": kantoItems,
  },
  "009": {
    "key": "009",
    "id": "WKJ0132",
    "name": "夢の島マリーナ",
    "location": {
      "lat": "35.62624",
      "lng": "139.85533"
    },
    "link": "https://www6.kaiho.mlit.go.jp/03kanku/tokyo/kisyou.html",
    "linkName": "東京海上保安部",
    "items": kantoItems,
  },
};

export default pointConfig;








